import Common from './Common';
import { PLAYNC_DOMAIN } from './const';

export const getSsoUrl = async(url) => {
    if(!url) {
        throw new Error(`url이 존재하지 않습니다.${e}`);
    }

    const { env } = Common?.instance || {};
    const curEnv = env in PLAYNC_DOMAIN ? env : 'live';
    const encodeUrl = getEncodeUrl(url);

    return fetch(`${PLAYNC_DOMAIN[curEnv]}/api/session/sso?return_url=${encodeUrl}`, {
        method: 'GET',
        credentials: 'include'
    })
    .then(res => res?.json())
    .catch(e => { throw new Error(`sso url api 호출에 실패하였습니다.\n${e}`); });
};

export const ssoUrlExternal = async(url) => {
    if(!url) {
        throw new Error(`url이 존재하지 않습니다.${e}`);
    }

    const { ssoUrl } = await getSsoUrl(url) || {};
    ssoUrl && window.open(ssoUrl, '_blank'); // 외부 브라우저로 이동
};

export const getEncodeUrl = (url) => {
    return encodeURIComponent(url);
};

export const checkHasParams = (url) => {
    let hasParam = false;
    let hasParams = false;

    if(url) {
        hasParam = (/\?.+/g).test(url); // query param 있는지 여부
        hasParams = (/\?(?=.*&).+/g).test(url); // param 2개 이상 있는지 여부
    }

    return { hasParam, hasParams };
};